import React from 'react';

import {
  selectHistorySlice,
  goNext,
  goPage,
  goPrevious,
} from '../redux/slices/historySlice';
import {
  useAppSelector,
  useAppDispatch,
  useFromChainWalletAddress,
} from '../hooks';

const ITEMS_PER_PAGE = 10;

const Pagination = () => {
  const dispatch = useAppDispatch();
  const { pageNumber, lastPageNumber, searchText, filterChain } =
    useAppSelector(selectHistorySlice);

  const fromChainWalletAddress = useFromChainWalletAddress();

  const handleGoPrevious = React.useCallback(() => {
    dispatch(goPrevious());
  }, [dispatch]);

  const handleGoNext = React.useCallback(() => {
    dispatch(goNext());
  }, [dispatch]);

  const handleOnChangePage = React.useCallback(
    async (page) => {
      dispatch(goPage(page));
    },
    [dispatch],
  );

  const previousEnable = React.useMemo(() => {
    if (lastPageNumber! <= 5) {
      return false;
    }
    if (pageNumber > 1) {
      return true;
    }
    return false;
  }, [pageNumber, lastPageNumber]);

  const nextEnable = React.useMemo(() => {
    if (lastPageNumber! <= 5) {
      return false;
    }
    if (lastPageNumber! - pageNumber >= 1) {
      return true;
    }
    return false;
  }, [pageNumber, lastPageNumber]);

  const firstPageActive = React.useMemo(() => pageNumber > 3, [pageNumber]);
  const lastPageActive = React.useMemo(
    () => pageNumber < lastPageNumber - 2,
    [pageNumber, lastPageNumber],
  );

  const pagesDisplay = React.useMemo(() => {
    let _pageNumberPent = pageNumber;

    if (pageNumber <= 3) {
      _pageNumberPent = 3;
    } else if (pageNumber >= lastPageNumber - 1) {
      _pageNumberPent =
        lastPageNumber === 4 ? lastPageNumber - 1 : lastPageNumber - 2;
    }

    const _range = Math.min(5, lastPageNumber);

    return Array.from(new Array(_range), (_, idx) => _pageNumberPent - 2 + idx);
  }, [pageNumber, lastPageNumber]);

  return (
    <ul className="pagination">
      <li className={previousEnable ? `page-item` : `page-item disabled`}>
        <a onClick={() => handleOnChangePage(pageNumber - 1)}>Previous</a>
      </li>
      {firstPageActive && (
        <>
          <li onClick={() => handleOnChangePage(1)} className="page-item">
            <a>1</a>
          </li>
          <li className="page-item">
            <span>...</span>
          </li>
        </>
      )}
      {pagesDisplay.map((pageNumberDisplay, idx) => (
        <li
          key={idx}
          onClick={() => handleOnChangePage(pageNumberDisplay)}
          className={
            pageNumber === pageNumberDisplay ? `page-item active` : `page-item`
          }
        >
          <a>{pageNumberDisplay}</a>
        </li>
      ))}
      {lastPageActive && (
        <>
          <li className="page-item">
            <span>...</span>
          </li>
          <li
            onClick={() => handleOnChangePage(lastPageNumber)}
            className="page-item"
          >
            <a>{lastPageNumber}</a>
          </li>
        </>
      )}

      <li className={nextEnable ? `page-item` : `page-item disabled`}>
        <a onClick={() => handleOnChangePage(pageNumber + 1)}>Next</a>
      </li>
    </ul>
  );
};

export default Pagination;
